export default __webpack_public_path__ + "static/media/subtract.794c3385.svg";